<template>
  <div class="map-kit-footer">
    <div class="map-kit-footer-attribution">
      <span v-html="attributionText" />
    </div>
    <div class="map-kit-footer-coordinates">
      <span v-if="cursorCoords && !screenshotMode">{{ cursorCoords }}</span>
      <div ref="scaleLineTarget" class="map-kit-scale-line" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ScaleLine } from 'ol/control';
import { toLonLat } from 'ol/proj';
import { ref, useTemplateRef, watch } from 'vue';

import { useMap } from '@/composables/useMap';
import { useScreenshotMode } from '@/composables/useScreenshotMode';

const { map } = useMap();
const { screenshotMode } = useScreenshotMode();

const cursorCoords = ref('');
const attributionText = ref(
  '&copy; <a href="https://www.maptiler.com/copyright/">MapTiler</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
);

const scaleLineTarget = useTemplateRef('scaleLineTarget');

const formatCoord = (lon: number, lat: number): string => {
  return `${lat.toFixed(4)}°, ${lon.toFixed(4)}°`;
};

// Use watch instead of onMounted because Vue 3 child onMounted fires
// BEFORE parent onMounted — the map ref isn't set yet at that point.
watch(
  () => map.value,
  (m) => {
    if (!m) return;

    // Scale line control
    const scaleLine = new ScaleLine({ units: 'metric' });
    if (scaleLineTarget.value) {
      scaleLine.setTarget(scaleLineTarget.value);
    }
    m.addControl(scaleLine);

    // Track pointer coordinates
    m.on('pointermove', (evt) => {
      const coord = toLonLat(evt.coordinate);
      cursorCoords.value = formatCoord(coord[0], coord[1]);
    });
  },
  { immediate: true },
);
</script>
